import { render } from "@/share/components/controls/holdDownButton/HoldDownButton.html?vue&type=template&id=0e071ef0&external"
import script from "@/share/components/controls/holdDownButton/HoldDownButton.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/holdDownButton/HoldDownButton.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__